module.exports = __webpack_public_path__ + "static/img/icon_facebook.15ad46c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channelServices/icon_facebook.png
// module id = 04yq
// module chunks = 0